import axios from 'axios';
import i18n from '/common/plugins/vue-i18n.js' 
import { headerWithLang } from './lang';

// this base url will be change based on
// if you need to point to production.
const PUBLIC_URL = process.env.VUE_APP_API_BASE_URL;
const BASE_URL = PUBLIC_URL + '/tenant';
const ACCESS_TOKEN = 'access_token';
const REFRESH_TOKEN = 'refresh_token';
const ID_TOKEN = 'id_token';
const LASTACTIVE = 'lastActive';
const IDLETIMELIMIT = 'idleTimeLimit';
const TENANT = 'tenant';
const USER = 'user';
const TENANTCENTERUSER = 'tenantcenter_user';
const TENANTCENTERLANG = 'tenantcenter_language';
const TENANTCENTER_ACCESS_TOKEN = 'tenantcenter_access_token';
const TENANTCENTER_REFRESH_TOKEN = 'tenantcenter_refresh_token';
const UPCHAT_LOGIN = 'upchat_login';
const SSO = 'sso';
const NOTICEBOARD_ISCLOSE = 'NoticeBoard_IsClose';

const tokenRequest = axios.create({
  baseURL: BASE_URL,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
    accept: 'application/json',
  },
});

const publicRequest = axios.create({
  baseURL: PUBLIC_URL,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
    accept: 'application/json',
  },
});

function  deleteCookie(name) {
  document.cookie = `${name}=;secure;sameSite=none;path=/;expires=Thu, 01 Jan 1970 00:00:00 GMT`;
}

const loginUser = (username, password, tenant, loginValiCode) => {
  //debugger;
  const loginBody = { username, password, loginValiCode };
  // let loginUrl = tokenRequest.defaults.baseURL.includes('api') ? '/token' : `${tenant}/api/token`;
  let loginURL = `/${tenant}/api/token`;
  return tokenRequest.post(loginURL, loginBody)
    .then((response) => {
      window.localStorage.setItem(ACCESS_TOKEN, response.data.access);
      window.localStorage.setItem(REFRESH_TOKEN, response.data.refresh);
      window.localStorage.setItem(TENANT, tenant);
      const upchat_url = response.data.upchat_dashboard;
      let upchat_host = "";
      if (upchat_url != "" && upchat_url != null && upchat_url != undefined) {
        const { origin } = new URL(upchat_url);
        upchat_host = origin;
      }
      var user = { 
        userid: response.data.userid,
        pic: response.data.pic,
        username: response.data.username,
        first_name: response.data.first_name,
        last_name: response.data.last_name,
        email: response.data.email,
        change_password: response.data.change_password,
        language: response.data.language,
        location: response.data.location,
        is_service_agent: response.data.is_service_agent,
        is_tech_user: response.data.is_tech_user,
        is_view_only_user: response.data.is_view_only_user,
        is_portal_user: response.data.is_portal_user,
        status: response.data.status,
        is_staff: response.data.is_staff,
        fcm_token: response.data.fcm_token,
        default_value: response.data.default_value,
        upchat_sso_link: response.data.upchat_sso_link,
        upchat_dashboard: response.data.upchat_dashboard,
        upchat_host: upchat_host,
        upgpt:response.data.upgpt,
      };
      window.localStorage.setItem('isUpchatUser', response.data.upchat);
      window.localStorage.setItem('isUpGPTUser', response.data.upgpt);
      window.localStorage.setItem(UPCHAT_LOGIN, false);
      window.localStorage.setItem(USER, JSON.stringify(user));
      window.localStorage.setItem('language', response.data.language);
      window.localStorage.setItem('location', response.data.location); 
      window.localStorage.setItem('is_staff', response.data.is_staff);     
      window.localStorage.setItem('fcm_token', response.data.fcm_token);
      i18n.locale = response.data.language

      // iframe和網頁版共有
      const expireDate = new Date();
      expireDate.setDate(expireDate.getDate() + 30);
      document.cookie = "access_token=" + response.data.access + `;secure;sameSite=none;path=/;expires=${expireDate.toUTCString()}`;
      document.cookie = "refresh_token=" + response.data.refresh + `;secure;sameSite=none;path=/;expires=${expireDate.toUTCString()}`;
      document.cookie = "tenant=" + tenant + `;secure;sameSite=none;path=/;expires=${expireDate.toUTCString()}`;
      document.cookie = "isUpchatUser=" + response.data.upchat + `;secure;sameSite=none;path=/;expires=${expireDate.toUTCString()}`;
      document.cookie = "isUpGPTUser=" + response.data.upgpt + `;secure;sameSite=none;path=/;expires=${expireDate.toUTCString()}`;
      document.cookie = `upchat_login=false;secure;sameSite=none;path=/;expires=${expireDate.toUTCString()}`;
      const userStr = encodeURIComponent(JSON.stringify(user));
      document.cookie = `user=${userStr};secure;sameSite=none;path=/;expires=${expireDate.toUTCString()}`;
      document.cookie = "need_redirect" + false + `;secure;sameSite=none;path=/;expires=${expireDate.toUTCString()}`;
      document.cookie = "language=" + response.data.language + `;secure;sameSite=none;path=/;expires=${expireDate.toUTCString()}`;
      document.cookie = "location=" + response.data.location + `;secure;sameSite=none;path=/;expires=${expireDate.toUTCString()}`;
      document.cookie = "is_staff=" + response.data.is_staff + `;secure;sameSite=none;path=/;expires=${expireDate.toUTCString()}`;
      document.cookie = "fcm_token=" + response.data.fcm_token + `;secure;sameSite=none;path=/;expires=${expireDate.toUTCString()}`;
      document.cookie = "sso=" + false + `;secure;sameSite=none;path=/;expires=${expireDate.toUTCString()}`;
      document.cookie = "lastActive=" + Math.floor(Date.now() / 1000) + `;secure;sameSite=none;path=/;expires=${expireDate.toUTCString()}`;
      // set tenant base url for authRequest
      // authRequest.defaults.baseURL = BASE_URL + `/${tenant}/api`;
      // tokenRequest.defaults.baseURL = BASE_URL + `/${tenant}/api`;
      return Promise.resolve(response.data);
    }).catch((error) => {
      return Promise.reject(error);
    });
};

const loginSsoUser = (tenant, loginValiCode, needRedirect=true) => {
  let ADFSloginURL = `/api/o365/login/`;
  let currentPath = window.location.href;
  return publicRequest.post(ADFSloginURL, {"tenant":tenant, "loginValiCode":loginValiCode, "currentUrl":currentPath, "needRedirect":needRedirect})
  .then(response => {
      const redirectPath = response.data;
      return redirectPath;
      // window.location.href = redirectPath;
  })
  .catch(error => {
    return Promise.reject(error.response.data);
  });
};

// login for UpSide
const loginUserUpSide = (username, password, tenant, loginValiCode) => {
  const loginBody = { username, password, loginValiCode };
  let loginURL = `/${tenant}/api/token`;
  return tokenRequest.post(loginURL, loginBody)
    .then((response) => {
      i18n.locale = response.data.language
      return Promise.resolve(response.data);
    }).catch((error) => {
      return Promise.reject(error);
    });
};
//login for Tenant Center
const loginTenantCenter = (username, password) => {
  const loginBody = { username, password};
  let loginURL = `/api/tenant_center/token`;
  return publicRequest.post(loginURL, loginBody)
    .then((response) => {
      window.localStorage.setItem(TENANTCENTER_ACCESS_TOKEN, response.data.access);
      window.localStorage.setItem(TENANTCENTER_REFRESH_TOKEN, response.data.refresh);
      var user = {
        userid: response.data.userid,
        username: response.data.username,
        first_name: response.data.first_name,
        last_name: response.data.last_name,
        email: response.data.email,
        can_manage_tenants: response.data.can_manage_tenants,
      };
      window.localStorage.setItem(TENANTCENTERUSER, JSON.stringify(user));
      window.localStorage.setItem(TENANTCENTERLANG, 'zh_TW');
      return Promise.resolve(response.data);
    }).catch((error) => {
      return Promise.reject(error);
    });
};

const refreshToken = () => {
  //debugger;
  const refreshBody = { refresh: window.localStorage.getItem(REFRESH_TOKEN) };
  const tenant = window.localStorage.getItem(TENANT);
  const refreshURL = `/${tenant}/api/token/refresh`;
  return tokenRequest.post(refreshURL, refreshBody)
    .then((response) => {
      window.localStorage.setItem(ACCESS_TOKEN, response.data.access);
      if (response.data.refresh) {
        window.localStorage.setItem(REFRESH_TOKEN, response.data.refresh);
      }
      return Promise.resolve(response.data);
    }).catch((error) => Promise.reject(error));
};

const isCorrectRefreshError = (status) => status === 401;

/*
 * authRequest
 *
 * This refreshes the request and retries the token if it is invalid.
 * This is what you use to create any requests that need the Tokens.
 * Reference: https://hackernoon.com/110percent-complete-jwt-authentication-with-django-and-react-2020-iejq34ta
 *
 * Example:
 *     authRequest.get('/path/to/endpoint/',extraParameters)
 *        .then(response=>{
 *          // do something with successful request
 *        }).catch((error)=> {
 *          // handle any errors.
 *        });
*/
const authRequest = axios.create({
  baseURL: BASE_URL,
  timeout: 30000,
  headers: headerWithLang(),
});
const tenantRequest = axios.create({
  baseURL: PUBLIC_URL,
  timeout: 30000,
  headers: headerWithLang(),
});

const logoutUser = async() => {
  let sso = window.localStorage.getItem('sso');
  let tenant = window.localStorage.getItem('tenant');
  let isSSO = sso === "true";
  if (isSSO) {
    try{
      // 這個登出會登出同個瀏覽器的帳戶
      const origin = window.location.origin;
      let need_redirect = window.localStorage.getItem('need_redirect');
      let redirectTo = '';
      if(need_redirect === "False") {
        redirectTo = `https://login.microsoftonline.com/contoso.onmicrosoft.com/oauth2/v2.0/logout`
        window.open(redirectTo, '_blank');
      } else {
        redirectTo = `https://login.microsoftonline.com/contoso.onmicrosoft.com/oauth2/v2.0/logout?post_logout_redirect_uri=${origin}/sso-upgpt-login?tenant=${tenant}`
        window.location.href = redirectTo;
      }
      // console.log("SSO Logout response:", redirectTo);
    } catch (error) {
      console.log("SSO Logout failed:", error);
    }
  }
  [
    "access_token",
    "refresh_token",
    "id_token",
    "tenant",
    "isUpchatUser",
    "isUpGPTUser",
    "upchat_login",
    "user",
    "need_redirect",
    "language",
    "location",
    "is_staff",
    "fcm_token",
    "sso",
    "lastActive",
    "idleTimeLimit"
  ].forEach(deleteCookie);
  window.localStorage.removeItem(LASTACTIVE);
  window.localStorage.removeItem(IDLETIMELIMIT);
  window.localStorage.removeItem(ACCESS_TOKEN);
  window.localStorage.removeItem(REFRESH_TOKEN);
  window.localStorage.removeItem(ID_TOKEN);
  window.localStorage.removeItem(TENANT);
  window.localStorage.removeItem(USER);
  window.localStorage.removeItem(NOTICEBOARD_ISCLOSE);
  window.localStorage.removeItem('isUpchatUser');
  window.localStorage.removeItem('isUpGPTUser');
  window.localStorage.removeItem(UPCHAT_LOGIN);
  window.localStorage.removeItem(SSO);
  window.localStorage.removeItem('ur_admin_project_id');   // 都更 Admin 記住的建案：自動登出也一併忘掉
  authRequest.defaults.headers.Authorization = '';
};

const errorInterceptor = (error) => {
  const originalRequest = error.config;
  if (error.response != null) {
    const { status } = error.response;
    if (isCorrectRefreshError(status)) {
      return refreshToken().then(() => {
        const headerAuthorization = `Bearer ${window.localStorage.getItem(ACCESS_TOKEN)}`;
        authRequest.defaults.headers.Authorization = headerAuthorization;
        originalRequest.headers.Authorization = headerAuthorization;
        return authRequest(originalRequest);
      }).catch((tokenRefreshError) => {
        let tenant = window.localStorage.getItem('tenant');
        // if token refresh fails, logout the user to avoid potential security risks.
        logoutUser();
        if (tenant != null || tenant != '')
          window.location.href = `/login?tenant=${tenant}`;
        else
          window.location.href = '/login';
        return Promise.reject(tokenRefreshError);
      });
    }  
  }
  return Promise.reject(error);
};

// add tenant to url for all requests
authRequest.interceptors.request.use(
  function (config) {
    const tenant = window.localStorage.getItem(TENANT);   
    const requestURL = config.url.charAt(0) == '/' ? config.url.slice(1) : config.url; 
    config.url = config.url.includes('api') ? config.url : `/${tenant}/api/${requestURL}`;
    config.headers.Authorization = `Bearer ${window.localStorage.getItem(ACCESS_TOKEN)}`;
    return config;
  }  
);

authRequest.interceptors.request.use(
  async function (config) {
    let idleTimeLimit = window.localStorage.getItem('idleTimeLimit');
    if (idleTimeLimit) {
      let lastActive = window.localStorage.getItem('lastActive');
      let recentActive = Math.floor(Date.now() / 1000);
      if (lastActive && (recentActive - lastActive) > idleTimeLimit){
        let id_token = window.localStorage.getItem('id_token');
        const payload = id_token.split('.')[1];
        const decoded = atob(payload.replace(/-/g, '+').replace(/_/g, '/'));
        const token_info = JSON.parse(decoded);
        let origin = window.location.origin;
        let tenant = window.localStorage.getItem('tenant');
        let need_redirect = window.localStorage.getItem('need_redirect');
        let revoke_url = ''
        if(need_redirect === "False") {
          revoke_url = `https://login.microsoftonline.com/contoso.onmicrosoft.com/oauth2/v2.0/logout?logout_hint=${token_info.login_hint}`
          window.open(revoke_url, '_blank');
        } else {
          revoke_url = `https://login.microsoftonline.com/contoso.onmicrosoft.com/oauth2/v2.0/logout?logout_hint=${token_info.login_hint}&post_logout_redirect_uri=${origin}/sso-upgpt-login?tenant=${tenant}`
          window.location.href = revoke_url;
        }
        window.localStorage.removeItem(LASTACTIVE);
        window.localStorage.removeItem(IDLETIMELIMIT);
        window.localStorage.removeItem(ACCESS_TOKEN);
        window.localStorage.removeItem(REFRESH_TOKEN);
        window.localStorage.removeItem(ID_TOKEN);
        window.localStorage.removeItem(TENANT);
        window.localStorage.removeItem(USER);
        window.localStorage.removeItem(NOTICEBOARD_ISCLOSE);
        window.localStorage.removeItem('isUpchatUser');
        window.localStorage.removeItem('isUpGPTUser');
        window.localStorage.removeItem(UPCHAT_LOGIN);
        window.localStorage.removeItem(SSO);
        window.localStorage.removeItem('ur_admin_project_id');   // 閒置逾時登出也一併忘掉
        authRequest.defaults.headers.Authorization = '';

        return Promise.reject(new axios.Cancel("Please log in again."));
      } 
      window.localStorage.setItem('lastActive', recentActive);
    }
    return config;
});


authRequest.interceptors.response.use(
  (response) => response, // this is for all successful requests.
  (error) => errorInterceptor(error), // handle the request
);

// Tantent Center
const logoutTenantCenterUser = () => {
  window.localStorage.removeItem(TENANTCENTER_ACCESS_TOKEN);
  window.localStorage.removeItem(TENANTCENTER_REFRESH_TOKEN);
  window.localStorage.removeItem(TENANTCENTERUSER);
  window.localStorage.removeItem(TENANTCENTERLANG);
  authRequest.defaults.headers.Authorization = '';
};

tenantRequest.interceptors.request.use(
  function (config) {
    config.headers.Authorization = `Bearer ${window.localStorage.getItem(TENANTCENTER_ACCESS_TOKEN)}`;
    return config;
  }
)
tenantRequest.interceptors.response.use(
  (response) => response, // this is for all successful requests.
  (error) => errorInterceptor(error), // handle the request
);

const unAuthenticated = () => (!(ACCESS_TOKEN in window.localStorage)
    && !(REFRESH_TOKEN in window.localStorage));

const searchString = function(val){
  if(typeof(val)==="string"){
      return encodeURIComponent(val);
  }else{
      return val;
  }
}
// Streaming
// 讓 fetch 也具備「401 -> refresh -> retry once」的能力
let __refreshPromise = null;

// 回傳：{ resp: Response|null, refreshFailed: boolean }
async function fetchWithAuthRetry(url, options = {}, { retry = true } = {}) {
  const accessToken = window.localStorage.getItem('access_token');
  const headers = new Headers(options.headers || {});
  if (accessToken) headers.set('Authorization', `Bearer ${accessToken}`);

  const resp = await fetch(url, { ...options, headers });

  if (resp.status !== 401) {
    return { resp, refreshFailed: false };
  }
  if (!retry) {
    return { resp, refreshFailed: false };
  }

  try {
    if (!__refreshPromise) {
      __refreshPromise = refreshToken().finally(() => {
        __refreshPromise = null;
      });
    }
    await __refreshPromise;
    console.log('refresh token success');
    const newAccessToken = window.localStorage.getItem('access_token');
    const retryHeaders = new Headers(options.headers || {});
    if (newAccessToken) retryHeaders.set('Authorization', `Bearer ${newAccessToken}`);

    const retryResp = await fetch(url, { ...options, headers: retryHeaders });
    return { resp: retryResp, refreshFailed: false };
  } catch (e) {
    return { resp: null, refreshFailed: true };
  }
}

export {
  tokenRequest, publicRequest, loginUser , loginSsoUser, loginUserUpSide, loginTenantCenter, logoutTenantCenterUser, logoutUser, refreshToken, authRequest, tenantRequest,
  errorInterceptor, BASE_URL, ACCESS_TOKEN, REFRESH_TOKEN, TENANTCENTER_ACCESS_TOKEN, TENANTCENTER_REFRESH_TOKEN, unAuthenticated,searchString, fetchWithAuthRetry
};

